import React, {Suspense, useEffect, useRef, useState} from "react";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { MarketplaceAppProvider } from "../../common/providers/MarketplaceAppProvider";
import { Route, Routes } from "react-router-dom";
import { AppConfigurationExtensionProvider } from "../../common/providers/AppConfigurationExtensionProvider";
import UiLocation from "@contentstack/app-sdk/dist/src/uiLocation";
import Stack from "@contentstack/app-sdk/dist/src/stack";
import ContentstackAppSDK from "@contentstack/app-sdk";
import {getLocales} from "../../common/stack/locales";
import {createDriver} from "../../common/emc/driver";

/**
 * All the routes are Lazy loaded.
 * This will ensure the bundle contains only the core code and respective route bundle
 * improving the page load time
 */
const AppConfigurationExtension = React.lazy(() => import("../AppConfiguration/AppConfiguration"));
const FullPageExtension = React.lazy(() => import("../FullPage/FullPage"));
const PageNotFound = React.lazy(() => import("../404/404"));
const DefaultPage = React.lazy(() => import("../FullPage/FullPage"));

const isEmcScriptLoaded = (): Promise<boolean> =>
  new Promise((resolve) => {
    const emcScript = document.createElement('script')
    // add random version to force bypassing cache
    const emc = process.env.REACT_APP_EMC_URL || '/management-client.js';
    const EMC_URL = `${emc}?v=${Date.now()}`
    emcScript.src = EMC_URL
    emcScript.type = 'module'

    emcScript.addEventListener('load', () => {
      resolve(true)
    })
    const head = document.querySelectorAll('head')[0]
    head.appendChild(emcScript)
  })

function App() {
  isEmcScriptLoaded()
  return (
    <ErrorBoundary>
      <MarketplaceAppProvider>
        <Routes>
          <Route path="/" element={<DefaultPage />} />
          <Route
            path="/app-configuration"
            element={
              <Suspense>
                <AppConfigurationExtensionProvider>
                  <AppConfigurationExtension />
                </AppConfigurationExtensionProvider>
              </Suspense>
            }
          />
          <Route
            path="/full-page"
            element={
              <Suspense>
                <FullPageExtension />
              </Suspense>
            }
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </MarketplaceAppProvider>
    </ErrorBoundary>
  );
}

export default App;
